var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMirrorBare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4083 9V11.6627H8L8.85207 14.2189H9.38462V24.4438C8.8465 24.6955 8.81404 25.0382 8.85207 25.7219C8.11559 25.9459 8.11235 26.3223 8.10662 26.9871L8.10651 27H14.6035C14.6224 26.2724 14.5698 25.9211 13.9645 25.7219C13.9952 24.9218 13.8496 24.6376 13.2189 24.4438V18.7988C15.0296 12.8343 20.7811 13.8994 22.1657 18.7988V24.4438C21.7252 24.6522 21.6251 24.9573 21.6331 25.7219C20.999 26.0288 20.9573 26.3573 20.9941 27H27.4911C27.5206 26.3844 27.4911 25.9349 26.7456 25.7219C26.77 25.1205 26.7262 24.8065 26.213 24.4438V14.2189H26.8521L27.5976 11.6627H24.0828V9H11.4083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorBare);
export default __webpack_public_path__ + "static/media/mirror-bare.f9ade6eca1165ce78e2c07216feccd2c.svg";
export { ForwardRef as ReactComponent };